import { render, staticRenderFns } from "./RetoursEnCours.vue?vue&type=template&id=23e67c0e&scoped=true&lang=true&"
import script from "./RetoursEnCours.vue?vue&type=script&lang=js&"
export * from "./RetoursEnCours.vue?vue&type=script&lang=js&"
import style0 from "./RetoursEnCours.vue?vue&type=style&index=0&id=23e67c0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e67c0e",
  null
  
)

export default component.exports